import _typeof from "@babel/runtime/helpers/typeof";
export function isIdType(item) {
  return typeof item === 'string' || typeof item === 'number';
}

/**
 * Extend an existing type and make some of its properties required or optional.
 * @example
 * interface Person {
 * 	name: string;
 * 	age?: number;
 * 	likesIceCream?: boolean;
 * }
 *
 * type PersonWithSomeRequired = SomeRequired<Person, 'age' | 'likesIceCream' >;
 * type PersonWithSomeOptional = SomeOptional<Person, 'name' >;
 */

export function isObjectWithId(object) {
  return _typeof(object) === 'object' && object !== null && 'id' in object;
}
export function checkIsNumber(value) {
  return typeof value === 'number';
}